import React from "react";
import { Sun, Moon } from "lucide-react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GameProvider, useGame } from "./context/GameContext";
import Home from "./pages/Home";
import RoomPage from "./pages/RoomPage";
import Notifications from "./components/Notifications";

const DarkModeToggle = () => {
  const { darkMode, toggleDarkMode } = useGame();
  return (
    <button
      onClick={toggleDarkMode}
      className="fixed bottom-4 left-4 w-10 h-10 rounded-full bg-white bg-opacity-20 hover:bg-opacity-30 flex items-center justify-center text-lg transition duration-200 z-50 shadow-lg backdrop-blur-sm"
      title={darkMode ? "Mode clair" : "Mode sombre"}
    >
      {darkMode ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
};

function App() {
  return (
    <GameProvider>
      <Router>
        <div className="App">
          <Notifications />
          <DarkModeToggle />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/room/:roomId" element={<RoomPage />} />
          </Routes>
          
        </div>
      </Router>
    </GameProvider>
  );
}

export default App;
